import { createRequestReducer } from '@fullstory/redux-util';
import { WatchHistoryActions } from './actions';
import { WatchHistoryTypes, WatchHistory } from './types';
import { combineReducers } from 'redux';

export const fetched = createRequestReducer<string[]>()(
  WatchHistoryTypes.FetchRequest,
  WatchHistoryTypes.FetchSuccess,
  WatchHistoryTypes.FetchFailure,
);

export const local = (state: WatchHistory = {}, action: WatchHistoryActions): WatchHistory => {
  switch (action.type) {
    case WatchHistoryTypes.SetWatched:
      return {
        ...state,
        [action.key]: true,
      };
    default:
      return state;
  }
};

type WatchHistoryReducerState = {
  fetched: ReturnType<typeof fetched>;
  local: ReturnType<typeof local>;
};

export const watchHistoryReducer = combineReducers<WatchHistoryReducerState>({
  fetched,
  local,
});
